import { BaseClass } from '/src/components/BaseClass.js';
import '../RIcon.js';
import successIcon from '@/assets/images/success.svg';
import warnIcon from '@/assets/images/warn.svg';
import errorIcon from '@/assets/images/error.svg';
const stylesheet = new CSSStyleSheet();
stylesheet.replaceSync(`
  :host {
    background-color: var(--color-accent);
    border-radius: 4px;
  }

  .bar {
    background-color: transparent;
    height: 2px;
  }
  
  .bar-content {
    background-color: var(--color-focus);
    width: 0;
    height: 100%;
  }
  
  .body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  
  @keyframes BarFilling {
    0% {
      width: 0;
    }
    
    100% {
      width: 100%;
    }
  }
  
  .icon {
    width: 40px;
    height: 40px;
  }
`);
const icons = {
    success: successIcon,
    warn: warnIcon,
    error: errorIcon,
};
export class RNotification extends BaseClass {
    constructor() {
        super();
        this.shadowRoot.adoptedStyleSheets.push(stylesheet);
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
        <div class="bar">
          <div class="bar-content"></div>
        </div>
        <div class="body">
          <r-icon url="${icons[this.type]}" class="icon"></r-icon>
          <div class="content">
            <slot></slot>
          </div>
        </div>
     `;
        this.#startTimer();
        this.#processClick();
        this.#processDblClick();
    }
    get duration() {
        return +this.getAttribute('duration');
    }
    get text() {
        return this.getAttribute('text') || '';
    }
    get type() {
        return this.getAttribute('type');
    }
    #timeoutId = 0;
    #processClick() {
        this.addEventListener('click', (e) => {
            this.#stopTimer();
        });
    }
    #processDblClick() {
        this.addEventListener('dblclick', () => {
            this.#stopTimer();
            this.dispatchEvent(new CustomEvent('expired'));
        });
    }
    #startTimer() {
        this.shadowRoot.querySelector('.bar-content').style.animation = `BarFilling ${this.duration}ms linear`;
        this.#timeoutId = setTimeout(() => {
            this.dispatchEvent(new CustomEvent('expired'));
            this.#timeoutId = null;
        }, this.duration);
    }
    #stopTimer() {
        if (this.#timeoutId) {
            clearTimeout(this.#timeoutId);
            this.#timeoutId = null;
        }
        this.shadowRoot.querySelector('.bar-content').style.animation = ``;
    }
}
customElements.define('r-notification', RNotification);
